/**
 * Gestaltung der Handbuchseiten — modullokal.
 *
 * ═══ WARUM DIESE WERTE NICHT IN `src/index.css` STEHEN ═════════════════════
 * Die Quell-App definiert `--color-border`, `--color-section-bg`,
 * `--color-status-ok` … in ihrem globalen Stylesheet und benutzt daneben die
 * Klassen `.a3-page`, `.section-header`, `.doc-table`, `.status-ok`. Nichts
 * davon wandert nach OS-IA mit: `src/index.css` ist die Grundlage ALLER
 * Bildschirme dieser Anwendung, und ein dort eingetragenes `--color-border`
 * mit dem Wert `#999` faerbte quer durch das Rechnungs-, Plan- und
 * Prueflistenmodul mit. Die Werte stehen deshalb hier und werden als
 * Inline-Stil gesetzt.
 *
 * Der zweite Grund ist inhaltlich: das Handbuch ist ein DOKUMENT, kein
 * Bildschirm. Es ist Serifenschrift auf Weiss mit haarfeinen Linien und darf
 * gerade nicht aussehen wie die uebrige Oberflaeche.
 *
 * ═══ WARUM EINE EIGENE DATEI UND NICHT IN `A3Seite.tsx` ════════════════════
 * Vier Bausteine brauchen dieselben Werte. Lagen sie in `A3Seite.tsx`, muesste
 * jeder von ihnen aus einer Komponentendatei importieren — `npm run lint`
 * laeuft mit `--max-warnings 0` und die Regel `react-refresh/only-export-
 * components` meldet genau das. Eine reine Konstantendatei loest es sauber.
 */

export const HANDBUCH_FARBEN = {
    linie: '#999999',
    linieStark: '#333333',
    abschnittHintergrund: '#e8e8e8',
    text: '#1a1a1a',
    textLeise: '#4b5563',
    risikoHoch: '#b91c1c',
    risikoMittel: '#d97706',
    risikoNiedrig: '#16a34a',
    statusOk: '#16a34a',
    statusOffen: '#d97706',
    statusFehlt: '#b91c1c',
} as const;

/** Serifenschrift wie in der Quell-App. Das Handbuch soll als Dokument
 *  gelesen werden, nicht als Bildschirmmaske. */
export const HANDBUCH_SCHRIFT = "'Times New Roman', Georgia, serif";

export type SeitenAusrichtung = 'quer' | 'hoch';

/**
 * Seitenverhaeltnisse.
 *
 * Die Kapitel sind A3 QUER (420 × 297) — so sieht der Muster-SiGe-Plan aus,
 * aus dem die Vorlage stammt. Der Aushang ist A3 HOCH (Entscheidung Nr. 4);
 * er entsteht in AP5 und nutzt dieselbe Seite mit `ausrichtung="hoch"`.
 */
export const SEITENVERHAELTNIS: Record<SeitenAusrichtung, string> = {
    quer: '420 / 297',
    hoch: '297 / 420',
};
